// extracted by mini-css-extract-plugin
export default {"overviewContainer":"styles_overviewContainer__u1NUs","title":"styles_title__dob24","overviewTable":"styles_overviewTable__8QXnS"};